define(
	'C3.ShoppingExtensions.IncomingEquipment.Model',
	[
		'SCModel',
		'Utils'
	],
	function(SCModelComponent, Utils){
		'use strict';

		var SCModel = SCModelComponent.SCModel;

		function MySCModel() {
			SCModel.call(this);

			// Define properties of the model.
			this.urlRoot = function() {
				Utils.getAbsoluteUrl(
		            getExtensionAssetsPath(
		                "services/IncomingEquipment.Service.ss"
		            )
		        )
			}
		}

		MySCModel.prototype = Object.create(SCModel.prototype);

		MySCModel.prototype.constructor = MySCModel;

		// Return the AMD constructor.
		return MySCModel;
	}
);
